import {FieldArray, Form, Formik} from 'formik'
import {isEmpty} from 'lodash'
import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import Modal from 'rsuite/Modal'
import * as Yup from 'yup'

//Manual import
import {StateParamsModel} from 'src/app/modules/common/Model'
import checkMultiLanguage from 'src/app/modules/common/checkMultiLanguage'
import FormTextBox from 'src/cms/helpers/components/forms/FormTextBox'
import FormTinyMce from 'src/cms/helpers/components/forms/FormTinyMce'
import * as faqManagerRedux from '../../faqManager/redux'

type Props = {
  open: boolean
  params?: StateParamsModel
  handleClose: () => void
  actionType: string
  editSelectedData?: any
  faqCategoryId?: string
}
const FORM_VALIDATION = Yup.object().shape({
  faq_qna: Yup.array()
    .of(
      Yup.object().shape({
        question: Yup.string().required('Question is required'),
        question_np: Yup.string().required('Question NP is required'),
        answer: Yup.string().required('Answer is required'),
        answer_np: Yup.string().required('Answer NP is required'),
      })
    )
    .required('At least one question is required'),
})

const AddFaqManager = ({
  open,
  params,
  handleClose,
  actionType,
  editSelectedData,
  faqCategoryId,
}: Props) => {
  const dispatch = useDispatch()

  const {loading, success} = useSelector((state: any) => state.faqManager)

  useEffect(() => {
    if (success) {
      dispatch(faqManagerRedux?.actions.getFaqManager(params, faqCategoryId))
      isEmpty(editSelectedData)
        ? toast.success('Faq Manager  added successfully')
        : toast.success('Faq Manager edited successfully')
      dispatch(faqManagerRedux?.actions.createFaqManagerReset())
      handleClose()
    }
  }, [success])
  const multiLanguage = checkMultiLanguage()
  return (
    <div className='modal-container'>
      <Modal
        open={open}
        onClose={handleClose}
        className='w-75'
        backdrop='static'
        keyboard={false}
        enforceFocus={false}
        data-cy='modal'
      >
        <Modal.Header>
          <Modal.Title data-cy='modal-title'>{actionType} Faq Manager</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Formik
              validationSchema={FORM_VALIDATION}
              initialValues={{
                faqCategoryId: faqCategoryId,
                faq_qna: [
                  {
                    question: '',
                    question_np: '',
                    answer: '',
                    answer_np: '',
                  },
                ],
              }}
              onSubmit={(values, {setSubmitting}) => {
                const formData: any = {
                  ...values,
                }
                dispatch(faqManagerRedux.actions.CreateFaqManger(formData))
              }}
            >
              {({isSubmitting, touched, handleChange, errors, values, setFieldValue}) => {
                useEffect(() => {
                  if (!isEmpty(editSelectedData.faq_qna)) {
                    const fields = ['faq_qna']
                    fields.forEach((field) => setFieldValue(field, editSelectedData[field], false))
                  }
                }, [])

                return (
                  <Form>
                    <div style={{paddingBottom: '10px'}}>
                      <FieldArray
                        name='faq_qna'
                        render={(arrayHelpers) => (
                          <div>
                            {values.faq_qna && values.faq_qna.length > 0
                              ? values.faq_qna.map((friend: any, index: any) => (
                                  <div className='row' key={index}>
                                    <div className='col-md-6 col-sm-6 col-xs-12'>
                                      <FormTextBox
                                        required={true}
                                        type='text'
                                        labelClassName='col-md-12'
                                        containerClassName='col-md-12'
                                        placeholder='Enter Question'
                                        label={multiLanguage ? 'Question' : 'Question (EN)'}
                                        name={`faq_qna.${index}.question`}
                                        onChange={handleChange}
                                        errors={errors}
                                        touched={touched}
                                      />
                                    </div>
                                    {multiLanguage ? null : (
                                      <div className='col-md-6 col-sm-6 col-xs-12'>
                                        <FormTextBox
                                          required={true}
                                          type='text'
                                          labelClassName='col-md-12'
                                          containerClassName='col-md-12'
                                          placeholder='Enter Question Nepali'
                                          label='Question (NP)'
                                          name={`faq_qna.${index}.question_np`}
                                          onChange={handleChange}
                                          errors={errors}
                                          touched={touched}
                                        />
                                      </div>
                                    )}

                                    <div className='col-md-6 col-sm-6 col-xs-12'>
                                      <FormTinyMce
                                        required={true}
                                        name={`faq_qna.${index}.answer`}
                                        handleChange={handleChange}
                                        label={multiLanguage ? 'Answer' : 'Answer (EN)'}
                                        initialValue={
                                          editSelectedData?.faq_qna[index]?.answer !== undefined
                                            ? editSelectedData.faq_qna[index].answer
                                            : ''
                                        }
                                        value={values?.faq_qna[index].answer}
                                      />
                                    </div>

                                    {multiLanguage ? null : (
                                      <div className='col-md-6 col-sm-6 col-xs-12'>
                                        <FormTinyMce
                                          required={true}
                                          name={`faq_qna.${index}.answer_np`}
                                          handleChange={handleChange}
                                          label='Answer (NP)'
                                          initialValue={
                                            editSelectedData?.faq_qna[index]?.answer_np !==
                                            undefined
                                              ? editSelectedData.faq_qna[index].answer_np
                                              : ''
                                          }
                                          value={values?.faq_qna[index]?.answer_np}
                                        />
                                      </div>
                                    )}
                                    {index > 0 && (
                                      <div className='col-md-12  justify-content-md-end text-end mb-2'>
                                        <button
                                          type='button'
                                          className='p-2 ps-5 pe-5 btn btn-secondary'
                                          onClick={() => arrayHelpers.remove(index)}
                                        >
                                          Remove
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                ))
                              : null}
                            <div className='d-flex justify-content-end'>
                              <button
                                className=' p-2 ps-3 pe-3 btn btn-primary w-100'
                                type='button'
                                onClick={() =>
                                  arrayHelpers.push({
                                    id: null,
                                    question: '',
                                    question_np: '',
                                    answer: '',
                                    answer_np: '',
                                  })
                                }
                                data-cy='modal-field-add'
                              >
                                + Add More
                              </button>
                            </div>
                          </div>
                        )}
                      />
                    </div>

                    <div className='d-flex justify-content-end px-9 '>
                      <button
                        type='submit'
                        disabled={loading}
                        className='btn btn-primary btn-sm ms-3'
                        data-cy='modal-submit'
                      >
                        Save
                      </button>
                      <button
                        type='button'
                        onClick={handleClose}
                        className='btn btn-secondary btn-sm ms-3'
                        data-cy='modal-cancel'
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                )
              }}
            </Formik>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}
export default AddFaqManager
